import { api } from "../api";
import { User } from "../interface";
import { store } from "../store";
import { lang } from "../lang";
import * as HelperSrc from "../HelperSrc";

async function createUser(email: string, isSuperuser: boolean, isStaff: boolean, isSupport: boolean, groups: string[]): Promise<User | null> {
    if (!api.userApi) {
        return null;
    }

    return api.userApi.usersCreate(email, isSuperuser, isStaff, isSupport, groups).then((response) => {
        if (response instanceof Error || (response.message && response.message.error)) {
            if (response instanceof Error) {
                HelperSrc.writeLog("error", response);
            } else {
                store.doNotice(lang[response.message.error]);
            }
        }

        return response as unknown as User;
    });
}

export { createUser };
